// extracted by mini-css-extract-plugin
export default {"tabs":"ManageView_tabs_q4E0x","item":"ManageView_item_KzG6q","container":"ManageView_container_wexf2"};